import { useIntl } from 'react-intl';

import { useAuth } from '@verantos-dev/core-auth';
import { PageHeaderAction } from '@verantos-dev/shared-components';

import {
  DialogActionType,
  useOrganizationsListDialogContext,
} from '../context/OrganizationsListDialogContext';

export const useOrganizationsListHeader = () => {
  const intl = useIntl();
  const {
    user: { isAdmin },
  } = useAuth();
  const { dispatch } = useOrganizationsListDialogContext();

  const title = intl.formatMessage({ id: 'organizations.title' });
  const createOrganizationBtn = intl.formatMessage({ id: 'organizations.createOrganizationBtn' });

  const createOrganizationsActionBtn: PageHeaderAction[] = isAdmin
    ? [
        {
          id: 'add-organization',
          label: createOrganizationBtn,
          startIcon: 'add',
          onClickHandler: () => {
            dispatch({ type: DialogActionType.OPEN_DIALOG, payload: 'createOrganization' });
          },
        },
      ]
    : [];

  return {
    title,
    createOrganizationBtn,

    createOrganizationsActionBtn,
  };
};
